<template>
  <div class="modal" v-bind:class="{ 'is-active': modalnotification.show }">
    <div class="modal-background"></div>
    <div
      class="modal-content has-text-centered"
      style="width: 45% !important; height: 60% !important;"
    >
      <div class="notification" v-bind:class="modalnotification.info.clase">
        <button class="delete" @click="cancelar"></button>
        <br />
        <i class="material-icons" style="color: #facea8; font-size: 100px;"
          >warning</i
        >
        <br />
        <h1 class="title is-2 space">{{ modalnotification.info.title }}</h1>
        <h2 class="subtitle is-4 space">
          {{ modalnotification.info.message }}
        </h2>
        <div class="field is-grouped is-justify-center">
          <p class="control">
            <button class="button is-large is-danger" @click="cancelar">
              Cancelar
            </button>
          </p>
          <p class="control">
            <button class="button is-large" @click="aceptar">Aceptar</button>
          </p>
        </div>
      </div>
      <!-- Any other Bulma elements you want -->
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="cancelar"
    ></button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["modalnotification"]),
  },
  methods: {
    aceptar() {
      this.$store.commit("changenotificationmodal", {
        result: {
          aceptar: true,
          data: this.modalnotification.info.data,
          isfolder: this.modalnotification.info.isfolder,
          isUnarchive: this.modalnotification.info.isUnarchive,
        },
      });
    },
    cancelar() {
      this.$store.commit("changenotificationmodal", {
        result: {
          aceptar: false,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.space {
  margin-bottom: 35px !important;
}

.is-white {
  color: #363636 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/Modalnotification.vue